export default __webpack_public_path__ + "static/leerling_gedemotiveerd-c87bf510e16cbeabd61b9f57fa974ca5.png";